import { useEffect, useRef, useState } from "react";
import { PenLine, Check } from "lucide-react";

/** The four handwriting fonts (must be listed in index.html Google Fonts import). */
export const HANDWRITING_FONTS = [
  { id: "Caveat",         label: "Caveat",         sample: "Study smart" },
  { id: "Kalam",          label: "Kalam",          sample: "Study smart" },
  { id: "Patrick Hand",   label: "Patrick Hand",   sample: "Study smart" },
  { id: "Homemade Apple", label: "Homemade Apple", sample: "Study smart" },
];

export default function HandwritingPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const current = HANDWRITING_FONTS.find((f) => f.id === value) || HANDWRITING_FONTS[0];

  return (
    <div ref={rootRef} className="relative inline-block">
      <button
        data-testid="btn-hw-font"
        onClick={() => setOpen((v) => !v)}
        title="Choose handwriting font"
        className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest px-4 py-2 border-2 border-black hover:bg-black hover:text-white transition-colors"
      >
        <PenLine className="w-3.5 h-3.5" />
        <span style={{ fontFamily: `"${current.id}", cursive`, textTransform: "none", letterSpacing: 0 }}>
          {current.label}
        </span>
      </button>

      {open && (
        <div
          data-testid="hw-font-popover"
          className="absolute right-0 mt-2 z-50 bg-white border-2 border-black shadow-[4px_4px_0_0_#000] p-2 min-w-[240px]"
        >
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 px-2 pt-1 pb-2">
            Handwriting
          </p>
          <ul className="space-y-1">
            {HANDWRITING_FONTS.map((f) => {
              const active = value === f.id;
              return (
                <li key={f.id}>
                  <button
                    data-testid={`hw-font-option-${f.id.replace(/\s+/g, "-").toLowerCase()}`}
                    onClick={() => {
                      onChange(f.id);
                      setOpen(false);
                    }}
                    className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-left border ${
                      active
                        ? "border-black bg-[#DBEAFE]"
                        : "border-transparent hover:bg-zinc-50"
                    }`}
                  >
                    <span
                      className="text-lg"
                      style={{ fontFamily: `"${f.id}", cursive` }}
                    >
                      {f.sample}
                    </span>
                    <span className="flex items-center gap-2">
                      <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                        {f.label}
                      </span>
                      {active && <Check className="w-3.5 h-3.5 text-[#3B82F6]" />}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
